module.exports = __webpack_public_path__ + "img/banner-rd.0aadee99.png";